import { gql } from '@apollo/client'

export const GET_ARTISTS = gql`
  query ($offset: Int, $limit: Int, $name: String) {
    getArtists(limit: $limit, offset: $offset, name: $name) {
      artists {
        id
        name
        facebook_id
        label_id
        gfk_id
        bio
        gps_status
        opus_id
        created_at
        social_media_kpi_facebook
        social_media_kpi_instagram
        social_media_kpi_twitter
        campaigns {
          id
          name
        }
      }
      total
    }
  }
`
